<template>
  <!-- Эти страницы публичны и предназначены для размещения на внешнем сайте. -->
  <v-card class="public-links" elevation="0">
    <v-card-title class="public-links__header">
      <div>
        <h2 class="public-links__title">Ссылки для публикации</h2>
        <p class="public-links__description">
          Публичные страницы приёмной комиссии для размещения на внешнем сайте организации.
        </p>
      </div>
    </v-card-title>

    <v-card-text class="public-links__content">
      <v-alert
        class="mb-5"
        type="info"
        variant="tonal"
        icon="mdi-web"
      >
        Эти страницы не требуют авторизации и доступны внешним пользователям.
      </v-alert>

      <v-alert
        v-if="copyMessage"
        class="mb-5"
        type="success"
        variant="tonal"
        closable
        @click:close="copyMessage = ''"
      >
        {{ copyMessage }}
      </v-alert>

      <div class="public-links__list">
        <article
          v-for="link in links"
          :key="link.id"
          class="public-links__item"
        >
          <div class="public-links__item-heading">
            <div class="public-links__icon">
              <v-icon :icon="link.icon" size="25" />
            </div>
            <div>
              <h3>{{ link.title }}</h3>
              <p>{{ link.description }}</p>
            </div>
          </div>

          <v-text-field
            class="public-links__field"
            :model-value="link.url"
            variant="outlined"
            density="comfortable"
            readonly
            hide-details
            :aria-label="'Публичная ссылка: ' + link.title"
            @focus="$event.target.select()"
          >
            <template #append-inner>
              <v-tooltip text="Копировать ссылку" location="top">
                <template #activator="{ props }">
                  <v-btn
                    v-bind="props"
                    icon="mdi-content-copy"
                    variant="text"
                    size="small"
                    :aria-label="'Копировать ссылку: ' + link.title"
                    @click="copyLink(link)"
                  />
                </template>
              </v-tooltip>
            </template>
          </v-text-field>

          <div class="public-links__actions">
            <v-btn
              color="primary"
              variant="tonal"
              prepend-icon="mdi-open-in-new"
              :href="link.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              Открыть страницу
            </v-btn>
          </div>
        </article>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PublicLinksSection',
  data() {
    return {
      copyMessage: ''
    };
  },
  computed: {
    publicRoot() {
      // Удаляем завершающий слеш, чтобы ссылки одинаково собирались при любой
      // конфигурации wwwroot.
      return String(this.$model.wwwroot || '').replace(/\/+$/, '');
    },
    links() {
      return [
        {
          id: 'application',
          title: 'Создание заявления',
          description: 'Публичная анкета для самостоятельной подачи заявления абитуриентом.',
          icon: 'mdi-account-edit-outline',
          url: this.publicRoot
            + '/procollege/manage_groups/admission/createApplicant/index#/'
        },
        {
          id: 'rating',
          title: 'Рейтинги абитуриентов',
          description: 'Публичная страница с актуальными рейтингами приёмной комиссии.',
          icon: 'mdi-format-list-numbered',
          url: this.publicRoot
            + '/procollege/manage_groups/admission/rating/index#/'
        }
      ];
    }
  },
  methods: {
    copyLink(link) {
      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        this.copyMessage = 'Выделите ссылку в поле и скопируйте её вручную.';
        return;
      }

      navigator.clipboard
        .writeText(link.url)
        .then(() => {
          this.copyMessage = 'Ссылка «' + link.title + '» скопирована.';
        })
        .catch(() => {
          this.copyMessage = 'Выделите ссылку в поле и скопируйте её вручную.';
        });
    }
  }
};
</script>

<style scoped>
.public-links {
  border: 1px solid #e4e7ec;
  border-radius: 12px;
}

.public-links__header {
  padding: 24px;
  white-space: normal;
}

.public-links__title {
  margin: 0;
  color: #1d2939;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
}

.public-links__description {
  margin: 6px 0 0;
  color: #667085;
  font-size: 14px;
  font-weight: 400;
}

.public-links__content {
  padding: 0 24px 24px;
}

.public-links__list {
  display: grid;
  gap: 16px;
}

.public-links__item {
  padding: 20px;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #f8fafc;
}

.public-links__item-heading {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 16px;
}

.public-links__item-heading h3 {
  margin: 0;
  color: #1d2939;
  font-size: 17px;
}

.public-links__item-heading p {
  margin: 4px 0 0;
  color: #667085;
  font-size: 14px;
}

.public-links__icon {
  display: flex;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #eaf3fc;
  color: #1565c0;
}

.public-links__field {
  background: #fff;
}

.public-links__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
</style>
